<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
            <div class="text-heading">
              <h2>Edit Campaign Type</h2>
            </div>
            <v-card-text>
              <v-form v-model="valid" @submit.prevent lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="8">
                      <v-select
                        v-model="select"
                        value="campaign_type"
                        :items="items"
                        :error-messages="selectErrors"
                        label="Campaign Type"
                        outlined
                        dense
                        required
                        @change="$v.select.$touch()"
                        @blur="$v.select.$touch()"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="8">
                      <v-text-field
                        v-model="name"
                        :error-messages="nameErrors"
                        label="Campaign Topic"
                        outlined
                        dense
                        required
                        @input="$v.name.$touch()"
                        @blur="$v.name.$touch()"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="buttonbox">
                    <v-btn class="campaign-btn" @click="submit"> Edit </v-btn>
                    <v-btn class="campaign-btn-clear" @click="clear">
                      Reset
                    </v-btn>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import axios from "axios";
export default {
  mixins: [validationMixin],

  validations: {
    name: { required, minLength: minLength(10), maxLength: maxLength(50) },
    select: { required },
  },

  data: () => ({
    name: "",
    select: null,
    items: [],
  }),

  computed: {
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      !this.$v.select.required && errors.push("Item is required");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.minLength &&
        errors.push("Topic must be at least 10 characters long");
        !this.$v.name.maxLength &&
        errors.push("Topic must not be greater than 50 characters");
      !this.$v.name.required && errors.push("topic is required.");
      return errors;
    },
  },
  mounted() {
    let id = this.$route.params.id ;
    let token = localStorage.getItem("token");
        axios
      .get(process.env.VUE_APP_ROOT_API + "admin/campaign-types", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        this.items = response.data;
        // console.log(this.items);
      });
    axios
      .get(process.env.VUE_APP_ROOT_API + "admin/campaign-topics/"+atob(id), {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        this.select = response.data.campaign_type_id;
       this.name = response.data.topic;
      });
     
  },

  methods: {
    submit() {
      this.$v.$touch();
        this.$loading(true);
        let id = this.$route.params.id ;
        let token = localStorage.getItem("token");
        let formdata = new FormData();
        formdata.append('_method', 'put');
        formdata.append("campaign_type_id", this.select);
        formdata.append("topic", this.name);
        console.log(formdata);
          axios
            .post(
              process.env.VUE_APP_ROOT_API + "admin/campaign-topics/"+atob(id),
              formdata,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Access-Control-Allow-Origin": "*",
                  Authorization: "Bearer " + token,
                },
              }
            )
            .then((response) => {
              this.$loading(false);
              console.log("Update",response);
              if (response.data.status == "success") {
                this.$router.push({ name: "CampaignTopic" }).catch(() => {});
                swal.fire({
                  title: "Success!",
                  text: "Record Updated Successfully",
                  icon: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#051d42",
                  confirmButtonText: "OK",
                });
              } else {
                this.error_message = "Invalid username or password.";
              }
            })
            .catch((error) => {
              this.$loading(false);
            });

    },
    clear() {
      this.$v.$reset();
      this.name = "";
      this.select = null;
    },
  },
};
</script>

<style></style>
